import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'
import { ApiService } from '../../../../../utility/api.service'

export const fetchOwners = createAsyncThunk('owners/fetchAll', async ({ filter = null, fields = null, offset = 0, limit = 250, sort }) => {
    const query = new URLSearchParams({
        filter: filter ? JSON.stringify(filter) : '',
        fields: fields ? JSON.stringify(fields) : '',
        offset,
        limit,
        sort: sort ? JSON.stringify(sort) : ''
    });
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/owners?${query}`)
    return { owners: Object.values(response.data), count: response.count }
})

export const fetchOwner = createAsyncThunk('owner/fetch', async ({ id }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/user/${id}`)
    return { owner: response.data.user }
})

export const updateOwner = createAsyncThunk('owner/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/user/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { owner: response.data.user }
})

const initialState = {
    owners: [],
    selectedOwner: null,
    loading: false,
    submitting: false,
    error: null,
    count: 0
}

const ownerSlice = createSlice({
    name: 'owners',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchOwners.pending]: (state) => {
            state.loading = true
        },
        [fetchOwners.fulfilled]: (state, { payload }) => {
            state.owners = payload.owners
            state.count = payload.count
            state.loading = false
        },
        [fetchOwners.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchOwner.pending]: (state) => {
            state.loading = true
        },
        [fetchOwner.fulfilled]: (state, { payload }) => {
            state.selectedOwner = payload.owner
            state.loading = false
        },
        [fetchOwner.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateOwner.pending]: (state) => {
            state.submitting = true
        },
        [updateOwner.fulfilled]: (state, { payload }) => {
            state.selectedOwner = payload.owner
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateOwner.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        }
    }
})

export default ownerSlice.reducer